import { Card } from '@ipfabric/ui-components/Card/Card';
import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import { storedAimIntegrations } from '../../../snippets/storedAimIntegrations';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const aimIntegrationsGroup = createFormSnippetGroup({
  snippets: {
    aimIntegrations: storedAimIntegrations,
  },
  render: ({ renderSnippet }) => (
    <SearchableSection
      id='aim-integrations'
      searchTerms={['Integration providers']}
      highlightOn={['aimIntegrations']}
      className='flex flex-col flex-1'
      wrapperClassName='flex flex-col flex-1'
    >
      <Card className='flex flex-col flex-1 rounded-tl-none' noShadow>
        <SearchableSection
          id='aim-integrations'
          className='flex flex-col flex-1'
          wrapperClassName='flex flex-col flex-1'
          highlightOn={['applicationMapping']}
        >
          {renderSnippet('aimIntegrations')}
        </SearchableSection>
      </Card>
    </SearchableSection>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('applicationMapping');
    control.setApplicationMappingSubTab('aimIntegrations');
  },
});
